// extracted by mini-css-extract-plugin
export default {"modal":"EditAddress_modal__GchFM","checkBox":"EditAddress_checkBox__IFJ8-"};